/**
 * Calculates the difference between two values on a cyclical range.
 *
 * @param a
 * @param b
 * @param c
 */
export function circularDifference(a: number, b: number, c: number): number {
    const hC = c * 0.5
    // Normalize the difference to the range (-c, c)
    const diff = ((b - a + hC) % c) - hC
    // Ensure the result is in (-c/2, c/2] (due to negative mod behavior in JS)
    return diff <= -hC ? diff + c : diff
}

/**
 * Calculates a normalized triangle-shaped score that peaks at the `ideal` value
 * and decreases linearly to 0 at the edges (0 or 1).
 *
 * This is useful for favoring values near a target in a normalized range [0, 1].
 *
 * @param value - The input value in the range [0, 1]
 * @param ideal - The desired center value (also in [0, 1])
 * @returns A score in [0, 1], with 1 at `ideal`, tapering off linearly
 */
export function idealCenteredScore(value: number, ideal: number): number {
    return 1 - Math.abs((value - ideal) / ideal)
}
